// 初使化 css
import 'core-js/modules/es6.array.for-each'
import 'core-js/modules/es6.array.filter'
import 'core-js/modules/es6.function.bind'
import 'core-js/modules/es6.object.keys'
import '@assets/style.less'

import defaults from '@store/defaults'
import core from '@core'

function jzpSign(options) {
  // 更新默认配置
  var config = $.extend({}, defaults, options || {})
  core(config)
}

window.jzpSign = jzpSign
